import {Spinner} from 'assets';
import React, {useEffect} from 'react';
import {Image} from 'react-bootstrap';
import styled from 'styled-components';

const Switch = styled.label`
    text-align: left;
    display: inline-block;
    width: 40px; /*=w*/
    height: 20px; /*=h*/
    margin: 4px;
    position: relative;

    input {
        display: none;
    }
`;

const SliderSpan = styled.span`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 30px;
    box-shadow:
        0 0 0 2px ${({theme}) => theme.colors.primary.main},
        0 0 4px ${({theme}) => theme.colors.primary.main};
    cursor: pointer;
    border: 4px solid transparent;
    overflow: hidden;
    transition: 0.2s;

    &:before {
        position: absolute;
        content: '';
        width: 100%;
        height: 100%;
        background: ${({theme}) => theme.colors.primary.main};
        border-radius: 30px;
        transform: translateX(-19px);
        transition: 0.2s;
    }

    input:checked + & {
        box-shadow:
            0 0 0 2px ${({theme}) => theme.colors.primary.main},
            0 0 8px ${({theme}) => theme.colors.primary.main};
        background: ${({theme}) => theme.colors.secondary.main};
    }

    input:checked + &:before {
        transform: translateX(19px); /*translateX(w-h)*/
        background: ${({theme}) => theme.colors.primary.main};
    }
`;

const SliderDiv = styled.div`
    text-align: right;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: fit-content;
`;
const StyledDiv = styled.div`
    color: ${({theme}) => theme.colors.primary.main};
`;

const Slider = ({
    name,
    value,
    handleChange,
    handleBlur,
    isLoading,
    AvailableText,
    HiddenText,
}: {
    name?: string;
    value: boolean;
    handleChange: React.ChangeEventHandler;
    handleBlur?: () => void;
    isLoading: boolean;
    AvailableText: string;
    HiddenText: string;
}) => {
    useEffect(() => {
        if (!!handleBlur) {
            handleBlur();
        }
    }, [value]);

    return (
        <SliderDiv>
            <StyledDiv>
                {isLoading ? (
                    <Image
                        className="icon_button"
                        style={{
                            backgroundColor: 'transparent',
                        }}
                        src={`data:image/svg+xml;base64, ${btoa(
                            String(Spinner)
                        )}`}
                    />
                ) : value ? (
                    AvailableText
                ) : (
                    HiddenText
                )}
            </StyledDiv>
            <Switch data-cy={`checkbox-${name}-label`}>
                <input
                    type="checkbox"
                    checked={value}
                    onChange={handleChange}
                    disabled={isLoading}
                    data-cy={`checkbox-${name}`}
                    name={name}
                    data-testid={name}
                />
                <SliderSpan />
            </Switch>{' '}
        </SliderDiv>
    );
};

export default Slider;
